__turbopack_context__.v({
  "isInvalid": "BaseCheckbox-module__RVlPgq__isInvalid",
  "root": "BaseCheckbox-module__RVlPgq__root",
});
